import script from "./SerialProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./SerialProduct.vue?vue&type=script&setup=true&lang=ts"

import "./SerialProduct.vue?vue&type=style&index=0&id=745e0c44&lang=less&scoped=true"

import exportComponent from "/Users/ivan/Codes/ripple/wfj-vto-hub/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745e0c44"]])

export default __exports__